import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { DeviceService } from '../services/device.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private deviceService: DeviceService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token   = this.authService.getToken();
    const company = this.authService.getSelectedCompany();

    const headers: Record<string, string> = {
      // Non-secret device id for session/device audit. Sent on every request
      // (including anonymous login/refresh) so sessions are attributed to a device.
      'X-Device-Id': this.deviceService.getDeviceId(),
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    // Attach the active company code as X-Company-Code so every API call
    // carries the context — no URL segment or query parameter needed.
    if (company?.compCode) {
      headers['X-Company-Code'] = company.compCode;
    }

    if (Object.keys(headers).length > 0) {
      req = req.clone({ setHeaders: headers });
    }

    return next.handle(req);
  }
}
